export default function Clinica() {
  return (
    <section id="clinica" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundColor: '#0E1412' }}>
      <div
        className="absolute top-0 left-0 right-0 h-[1px]"
        style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(200, 169, 106, 0.15) 50%, transparent 100%)' }}
      />

      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="flex-1 w-full">
            <div className="relative overflow-hidden rounded-[28px] aspect-[16/10]"
              style={{ border: '1px solid rgba(200, 169, 106, 0.12)' }}
            >
              <img
                src="https://storage.readdy-site.link/project_files/a5718860-87a7-40cd-af11-814f205df039/c77c6a29-2196-42a6-b7bf-bdc539264936_compressed_unnamed-1.webp"
                alt="Infinity Clínica Avançada"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <p
              className="text-sm tracking-[0.15em] mb-4"
              style={{
                fontFamily: 'var(--font-body)',
                color: '#C8A96A',
                fontWeight: 500,
              }}
            >
              CLÍNICA
            </p>
            <h2
              className="text-3xl md:text-4xl mb-6"
              style={{
                fontFamily: 'var(--font-heading)',
                color: '#F8F7F5',
                fontWeight: 500,
                lineHeight: 1.2,
              }}
            >
              Infinity Clínica Avançada
            </h2>
            <p
              className="text-sm md:text-base leading-relaxed mb-8"
              style={{
                fontFamily: 'var(--font-body)',
                color: 'rgba(248, 247, 245, 0.5)',
                fontWeight: 300,
                lineHeight: 1.8,
              }}
            >
              Um espaço pensado para oferecer a melhor experiência em cada consulta. Conforto, privacidade e tecnologia se unem para cuidar da sua saúde com excelência.
            </p>

            <div
              className="rounded-[20px] overflow-hidden mb-6"
              style={{ border: '1px solid rgba(248, 247, 245, 0.08)' }}
            >
              <iframe
                title="Localização Infinity Clínica Avançada"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.3!2d-38.518!3d-3.725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c749a1c0e7e0e1%3A0x0!2sRua+Silva+Paulet%2C+984+-+Meireles%2C+Fortaleza+-+CE%2C+Brasil!5e0!3m2!1spt-BR!2sbr!4v1690000000000"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div className="flex flex-col gap-2 mb-8">
              <div className="flex items-center gap-3">
                <i className="ri-time-line" style={{ color: '#C8A96A' }} />
                <span
                  className="text-sm"
                  style={{ fontFamily: 'var(--font-body)', color: 'rgba(248, 247, 245, 0.6)', fontWeight: 400 }}
                >
                  Segunda a Sexta: 8h às 18h
                </span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-map-pin-line" style={{ color: '#C8A96A' }} />
                <span
                  className="text-sm"
                  style={{ fontFamily: 'var(--font-body)', color: 'rgba(248, 247, 245, 0.6)', fontWeight: 400 }}
                >
                  R. Silva Paulet, 984 - Meireles, Fortaleza - CE
                </span>
              </div>
            </div>

            <a
              href="https://wa.me/5585999372109?utm_source=site&utm_medium=clinica_section&utm_content=agendar_consulta"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium tracking-[0.03em] whitespace-nowrap cursor-pointer transition-all duration-300"
              style={{
                backgroundColor: '#25D366',
                color: '#FFFFFF',
                fontFamily: 'var(--font-body)',
              }}
            >
              <i className="ri-whatsapp-line text-lg" />
              Falar pelo WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}